import { createSlice } from "@reduxjs/toolkit";
import { EventInitialLoad } from "../thunk/EventThunk";




const initialState = {
    events: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};


export const EventSlice = createSlice({
    name: "event",
    initialState,
    reducers: {
        resetEvent: (state, action) => {
            return {
                ...initialState
            };

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(EventInitialLoad.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(EventInitialLoad.fulfilled, (state, action) => {

                // console.log({ action });

                return {
                    ...state,
                    events: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(EventInitialLoad.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            })

    },
});


export const { resetEvent } = EventSlice.actions;

export const EventReducer = EventSlice.reducer;